import React, { useEffect, useState } from 'react'

import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"
import { Link, useParams } from 'react-router-dom'
import { get, post } from '../../helper/helper_api';

export default function Category() {

    const paramas = useParams();

    const [data, setData] = useState(undefined);
    const [catID, setCatID] = useState(undefined);
    const [product, setProduct] = useState(undefined);
    const [productcount, setProductcount] = useState(undefined);
    const [ind, setInd] = useState(undefined);
    const [curruntData, setCurruntData] = useState(undefined);

    useEffect(() => {

        if (paramas?.name)
            getData(paramas?.name)
    }, [paramas])



    const getData = (title) => {
        get(`category/title?title=${title}`)
            .then(res => {
                if (res?.statusCode == 200) {
                    setData(res?.data)
                    setCatID(res?.data?.subCat[0]?._id)
                    setProductcount(res?.data?.subCat[0]?.product)
                    setInd(0)

                }
            }).catch(err => {
                console.log(err)
            })

        console.log(paramas?.name)
    }

    const getCatData = (item) => {
        setCatID(item?._id)
        setProductcount(item?.setProductcount)

    }

    console.log('productcount',productcount)


    useEffect(() => {
        if (catID) {
            let body = {
                subCatId: [catID]
            }
            post('product/list', body)
                .then(res => {

                    console.log('res product', res)
                    if (res?.statusCode == 200) {
                        setProduct(res?.data)
                    }
                }).catch(err => {
                    console.log(err)
                })
        }
    }, [catID])


    const popupData = (item) => {
        setCurruntData(item)
    }


    console.log('curruntData', curruntData)


    return (
        <>


            <section class="page-title-center-alignment cover-background top-space-padding cat_page">

                <div class="container">

                    <div class="row">

                        <div class="col-12 text-center position-relative page-title-extra-large">

                            <h1 class="alt-font d-inline-block fw-700 ls-minus-05px text-base-color mb-10px mt-3 md-mt-50px">{data?.title}</h1>

                        </div>

                        <div class="col-12 breadcrumb breadcrumb-style-01 d-flex justify-content-center">

                            <ul>

                                <li><Link to="/">Home</Link></li>

                                <li>{data?.title}</li>

                            </ul>

                        </div>

                    </div>

                </div>

            </section>

            {/* <!-- end page title --> */}

            {/* <!-- start section --> */}

            <section class="ps-6 pe-6 lg-ps-3 lg-pe-3 sm-ps-0 sm-pe-0">

                <div class="container-fluid">

                    <div class="row flex-row-reverse">

                        <div class="col-xxl-10 col-lg-9 ps-5 md-ps-15px md-mb-60px">

                            <div class="toolbar-wrapper border-bottom border-color-extra-medium-gray d-flex flex-column flex-sm-row align-items-center w-100 mb-40px md-mb-30px pb-15px" data-anime='{ "translateY": [0, 0], "opacity": [0,1], "duration": 600, "delay":50, "staggervalue": 150, "easing": "easeOutQuad" }'>



                                <div class="ms-20px xs-ms-0">Showing { productcount } results</div>



                            </div>

                            <ul class="shop-boxed shop-wrapper grid_loading grid grid-4col xxl-grid-4col xl-grid-3col lg-grid-3col md-grid-2col sm-grid-2col xs-grid-1col gutter-large text-center" data-anime='{ "el": "childs", "translateY": [50, 0], "opacity": [0,1], "duration": 600, "delay":100, "staggervalue": 150, "easing": "easeOutQuad" }'>

                                <li class="grid-sizer"></li>

                                {/* <!-- start shop item --> */}
                                <ResponsiveMasonry
                                    columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}
                                >
                                    <Masonry>
                                        {
                                            product?.map((item, index) => {
                                                return (
                                                    <div className='category_section'>
                                                        <div class="shop-box pb-25px">

                                                            <div class="shop-image">

                                                                <a href="javascript:;" onClick={() => popupData(item)} data-bs-toggle="modal" data-bs-target="#exampleModal">

                                                                    <img src={item?.images[0]} alt="" />

                                                                    <span class="lable new">New</span>

                                                                    <div class="product-overlay bg-gradient-extra-midium-gray-transparent"></div>

                                                                </a>

                                                                <div class="shop-hover d-flex justify-content-center">



                                                                    <a href="javascript:;" onClick={() => popupData(item)} class="bg-white w-45px h-45px text-dark-gray d-flex flex-column align-items-center justify-content-center rounded-circle ms-5px me-5px box-shadow-medium-bottom" data-bs-toggle="tooltip" data-bs-placement="top" title="Quick shop"><i class="feather icon-feather-eye fs-15"></i></a>

                                                                </div>

                                                            </div>

                                                            <div class="shop-footer text-center pt-20px">

                                                                <a href="javascript:;" onClick={() => popupData(item)} class="text-dark-gray fs-17 alt-font fw-600">{item?.title}</a>

                                                                {/* <div class="fw-500 fs-15 lh-normal"><del>$30.00</del>$23.00</div> */}

                                                            </div>

                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }



                                    </Masonry>
                                </ResponsiveMasonry>
                            </ul>

                            <div class="w-100 d-flex mt-3 justify-content-center" data-anime='{ "translateY": [0, 0], "opacity": [0,1], "duration": 600, "delay":100, "staggervalue": 150, "easing": "easeOutQuad" }'>

                                <ul class="pagination pagination-style-01 fs-13 fw-500 mb-0">

                                    <li class="page-item"><a class="page-link" href="#"><i class="feather icon-feather-arrow-left fs-18 d-xs-none"></i></a></li>

                                    <li class="page-item"><a class="page-link" href="#">01</a></li>

                                    <li class="page-item active"><a class="page-link" href="#">02</a></li>

                                    <li class="page-item"><a class="page-link" href="#">03</a></li>

                                    <li class="page-item"><a class="page-link" href="#">04</a></li>

                                    <li class="page-item"><a class="page-link" href="#"><i class="feather icon-feather-arrow-right fs-18 d-xs-none"></i></a></li>

                                </ul>

                            </div>

                        </div>

                        <div class="col-xxl-2 col-lg-3 shop-sidebar">

                            <div class="mb-30px">

                                <span class="alt-font fw-600 fs-17 text-dark-gray d-block mb-10px">{data?.title}</span>

                                <ul class="fs-15 shop-filter category-filter">
                                    {
                                        data?.subCat?.length ?
                                            <>
                                                {data?.subCat?.map((item, index) => {
                                                    return (
                                                        <li onClick={() => { getCatData(item); setInd(index) }}><a href='javascript:;' className={ind == index ? 'active' : null}><span class="product-cb product-category-cb"></span>{item?.title}</a><span class="item-qty">{item?.product}</span></li>
                                                    )
                                                })}
                                            </>
                                            : null
                                    }

                                </ul>

                            </div>



                        </div>

                    </div>

                </div>

            </section>


            {/* <!-- Modal --> */}
            <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-fullscreen">
                    <div class="modal-content">

                        <div class="modal-body product_popup">
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            <section class="pt-40px pb-0">

                                <div class="container">

                                    <div class="row">

                                        <div class="col-lg-5 offset-lg-1 md-mb-40px" >

                                            <div class="row overflow-hidden position-relative">

                                                <div class="col-12 position-relative product-image">

                                                    <div class="swiper product-image-slider product_image_slider" data-slider-options='{ "spaceBetween": 0, "watchOverflow": true, "navigation": { "nextEl": ".slider-product-next", "prevEl": ".slider-product-prev" }, "thumbs": { "swiper": { "el": ".product-image-thumb", "slidesPerView": "5", "spaceBetween": 15 } } }' data-swiper-thumb-click="1">

                                                        <div class="swiper-wrapper">

                                                            {/* <!-- start slider item --> */}
                                                            {
                                                                curruntData?.images?.map((item, index) => {
                                                                    return (
                                                                        <div class="swiper-slide gallery-box">

                                                                            <a href={item} data-group="lightbox-gallery" title="Minimalist wooden chair">

                                                                                <img class="w-60" src={item} alt="" />

                                                                            </a>

                                                                        </div>
                                                                    )
                                                                })
                                                            }



                                                        </div>

                                                    </div>

                                                    <div class="slider-product-next swiper-button-next border-radius-100 border border-1 border-color-extra-medium-gray"><i class="fa fa-chevron-right text-dark-gray icon-very-small"></i></div>

                                                    <div class="slider-product-prev swiper-button-prev border-radius-100 border border-1 border-color-extra-medium-gray"><i class="fa fa-chevron-left text-dark-gray icon-very-small"></i></div>

                                                </div>

                                                <div class="col-12 position-relative">

                                                    <div class="swiper-container product-image-thumb">

                                                        <div class="swiper-wrapper">
                                                            {
                                                                curruntData?.images?.map((item, index) => {
                                                                    return (
                                                                        <div class="swiper-slide"><img class="w-100" src={item} alt="" /></div>
                                                                    )
                                                                })
                                                            }


                                                          

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                        <div class="col-lg-6  product-info" >

                                            {/* <span class="fw-500 text-dark-gray d-block">Interio</span> */}

                                            <h5 class="alt-font text-dark-gray fw-700 mb-10px">{curruntData?.title}</h5>

                                            <div class="d-block d-sm-flex align-items-center mb-20px">

                                                <div><span class="text-dark-gray fw-500">SKU: </span>{curruntData?.productId}</div>

                                            </div>
                                            {
                                                curruntData?.priceType == 'Start Price' && <div class="product-price mb-10px">

                                                    <span class="text-dark-gray fs-28 xs-fs-24 fw-700 ls-minus-1px">{curruntData?.price}</span>

                                                </div>
                                            }




                                            <p dangerouslySetInnerHTML={{ __html: curruntData?.desc }}></p>



                                            <div class="d-flex align-items-center flex-column flex-sm-row mb-20px position-relative">

                                                <div class="quantity me-15px xs-mb-15px order-1">

                                                    <button type="button" class="qty-minus">-</button>

                                                    <input class="qty-text" type="text" id="1" value="1" aria-label="qty-text" />

                                                    <button type="button" class="qty-plus">+</button>

                                                </div>

                                                <a href="#" class="btn btn-cart btn-extra-large btn-switch-text btn-box-shadow btn-none-transform btn-dark-gray left-icon border-radius-5px me-15px xs-me-0 order-3 order-sm-2">

                                                    <span>

                                                        <span><i class="feather icon-feather-shopping-bag"></i></span>

                                                        <span class="btn-double-text" data-text="Price Request">Price Request</span>

                                                    </span>

                                                </a>



                                            </div>



                                        </div>

                                    </div>

                                </div>

                            </section>

                        </div>

                    </div>
                </div>
            </div>
            {/* <!-- end section --> */}
        </>
    )
}
